export default __webpack_public_path__ + "static/media/next_icon.37bb4a20.svg";